export default [
	{  // 商品列表
		path: 'product_list',
		name: 'm_product_list',
		component: () => import('@/pages/product/product_list')
	}, {  // 商品审核列表
		path: 'product_audit_list',
		name: 'm_product_audit_list',
		component: () => import('@/pages/product/product_audit_list')
	}, {  // 商品发布
		path: 'product_apply',
		name: 'product_apply',
		meta: {
			title: '发布商品'
		},
		props: route => route.query,
		component: () => import('@/pages/product/product_apply')
	}, {  // 商品详情
		path: 'product_detail/:id',
		name: 'product_detail',
		meta: {
			title: '服务详情'
		},
		props: route => route.params,
		component: () => import('@/pages/product/product_detail')
	}, {  // 商品编辑
		path: 'product_edit/:id',
		name: 'product_edit',
		meta: {
			title: '编辑商品'
		},
		props: route => route.params,
		component: () => import('@/pages/product/product_edit')
	}, {  // 商品类目
		path: 'product_classify',
		name: 'm_product_type',
		component: () => import('@/pages/product/product_classify')
	},{  // 商品排序
		path: 'product_sort',
		name: 'm_product_sort',
		component: () => import('@/pages/product/product_sort')
	}, {  // 商品分类
		path: 'product_group',
		name: 'm_product_group',
		component: () => import('@/pages/product/product_group')
	}, {  // 商品参数
		path: 'product_param',
		name: 'm_product_param',
		component: () => import('@/pages/product/product_param')
	}, {  // 商品属性
		path: 'product_attr',
		name: 'm_product_attr',
		component: () => import('@/pages/product/product_attr')
	}, {  // 服务标签
		path: 'product_service_tag',
		name: 'm_product_service_tag',
		component: () => import('@/pages/product/product_service_tag')
	}, {  // 定制项配置
		path: 'product_custom_config',
		name: 'm_product_custom',
		component: () => import('@/pages/product/product_custom_config')
	}, {  // 运费模板
		path: 'freight_template',
		name: 'm_freight_template',
		component: () => import('@/pages/product/freight_template')
	}, {  // 新建运费模板
		path: 'freight_template_add',
		name: 'freight_template_add',
		meta: {
			title: '新建运费模板'
		},
		component: () => import('@/pages/product/freight_template_add')
	}, {  // 编辑运费模板
		path: 'freight_template_edit/:id',
		name: 'freight_template_edit',
		meta: {
			title: '编辑运费模板'
		},
		props: route => route.params,
		component: () => import('@/pages/product/freight_template_edit')
	}, {  // 品牌管理
		path: 'product_brand',
		name: 'm_product_brand',
		component: () => import('@/pages/product/product_brand')
	},{  // 配送方式列表
		path: 'delivery_mode_list',
		name: 'm_logistics_company',
		component: () => import('@/pages/system/delivery_mode_list.vue')
	},{  // 标志物流列表
		path: 'standard_logistics_list',
		name: 'm_standard_logistics',
		component: () => import('@/pages/system/standard_logistics_list.vue')
	}
];